<template>
  <div id="pageTable">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex lg12>
          <v-card>
            <v-toolbar card color="white">
              <v-text-field
                flat
                hide-details
                :placeholder="$t('search')"
                prepend-icon="search"
                solo
                v-model="search"
              ></v-text-field>
              <v-btn
                v-if="edit && hasPermission('CREATE_PITCH')"
                @click="sendEmit('create')"
                color="primary"
                small
              >{{$t('new')}}</v-btn>
            </v-toolbar>
            <v-divider></v-divider>
            <v-card-text class="pa-0">
              <v-data-table
                :headers="headers"
                :items="aulasDefinition"
                :loading="loading"
                :rows-per-page-items="[10,25,50,{text:'All','value':-1}]"
                :search="search"
                class="elevation-1"
                item-key="name"
              >
                <template slot="items" slot-scope="props">
                  <td class="justify-center px-0" v-if="edit">
                    <v-btn v-if="hasPermission('EDIT_PITCH')" color="success" flat icon>
                      <v-icon
                        @click="sendEmit('update', props.item)"
                        class="icon material-icons"
                      >create</v-icon>
                    </v-btn>
                    <v-btn v-if="can('delete','pitch',props.item)" color="error" flat icon>
                      <v-icon
                        @click="sendEmit('delete', props.item)"
                        class="icon material-icons"
                      >delete</v-icon>
                    </v-btn>
                  </td>
                  <td>{{ props.item.name }}</td>
                  <td>
                    <div class="recuadrofoto">
                      <img
                        :src="resolveUrl(props.item.photo)"
                        :alt="props.item.name"
                        width="100%"
                        v-if="props.item.photo"
                      />
                      <div v-else>Sin imagen</div>
                    </div>
                  </td>
                </template>
              </v-data-table>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { dateFormat } from '../../../helpers/dateHelper'

export default {
  name: 'list',
  props: {
    filterStadium: {
      type: Object,
      required: true
    },
    edit: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      status: false,
      search: ''
    }
  },
  computed: {
    ...mapState({
      stadium: state => state.stadiums.stadiumSelected,
      listAulas: state => state.pitches.listPitches,
      loading: state => state.pitches.loading
    }),
    headers() {
      let result = []
      if (this.edit) {
        result.push({
          text: this.$t('actions'),
          align: 'center',
          value: ''
        })
      }
      result = result.concat([
        {
          text: this.$t('name'),
          align: 'center',
          value: 'name'
        },
        {
          text: this.$t('image'),
          align: 'center',
          value: 'photo'
        }
      ])
      return result
    },
    aulasDefinition() {
      if (this.status) {
        return []
      }
      if (Object.entries(this.filterStadium).length !== 0) {
        let aulas = []
        let me = this
        this.filterStadium.pitches.forEach(item => {
          let tempItem = item
          tempItem.centroId = me.filterStadium._id
          aulas.push(tempItem)
        })
        return aulas
      }
      return this.listAulas
    }
  },
  methods: {
    ...mapActions({
      getOne: 'pitches/setOne',
      setStadium: 'pitches/setStadium'
    }),
    dateFormat(value) {
      return dateFormat(value, false)
    },
    resolveUrl(src) {
      return process.env.VUE_APP_IMAGE_URL + src
    },
    sendEmit(evento, id = null) {
      if (evento !== 'delete' && evento !== 'create' && evento !== 'update') {
        return
      }
      let element = null
      if (id) {
        element = {
          idStadium: id.centroId,
          idPitch: id._id
        }
      }
      this.status = true
      switch (evento) {
        case 'create':
          this.$emit('create')
          break
        case 'update':
          if (element) {
            this.setStadium(element.idStadium)
            this.getOne(element).then(_ => {
              this.$emit('update')
            })
          }
          break
        case 'delete':
          if (element) {
            this.setStadium(element.idStadium)
            this.getOne(element).then(_ => {
              this.$emit('remove')
            })
          }
          break
      }
    }
  }
}
</script>

<style scoped>
.cursor {
  cursor: pointer;
}

.line-bottom {
  border-bottom: 1px solid #000;
}

.text-left {
  text-align: left;
}

.success--text {
  color: green;
}

.error--text {
  color: red;
}
table tr th {
  text-align: center !important;
}
table tr td {
  text-align: center !important;
}

.recuadrofoto {
  width: 140px;
  margin: auto;
}
</style>
